import { Size } from "../types/size.type";
import { Style } from "../types/style.type";
import { Type } from "../types/button-type.type";
import { TypoColor } from "../../../../components/typo/types/color.type";
import { IconColor } from "../../../../components/icon/types/icon-color.types";

export function constructTypoColor(type: Type, style: Style): TypoColor {
    let typoColor: TypoColor = 'primary';
    switch (type) {
        case 'primary':
            if (style == 'filled') {
                typoColor = 'light'
            } else {
                typoColor = 'brand'
            }
            break;
        case 'secondary':
            typoColor = 'primary';
            break;
        case 'success':
            if (style == 'filled') {
                typoColor = 'light'
            }
            else if (style == 'outline') {
                typoColor = 'success'
            }
            break;
        case 'danger':
            if (style == 'filled') {
                typoColor = 'light'
            }
            else if (style == 'outline') {
                typoColor = 'danger'
            }
            break;
        case 'warning':
            if (style == 'filled') {
                typoColor = 'light'
            }
            else if (style == 'outline') {
                typoColor = 'warning'
            }
            break;
        case 'info':
            if (style == 'filled') {
                return 'light'
            }
            else if (style = 'outline') {
                typoColor = 'info'
            }
            break;
    }
    return typoColor;
}

export function constructIconColor(type: Type, style: Style) {
    let iconColor: IconColor = 'primary';
    switch (type) {
        case 'primary':
            if (style == 'filled') {
                iconColor = 'light';
            }
            else {
                iconColor = 'brand';
            }
            break;
        case 'secondary':
            iconColor = 'muted';
            break;
        case 'success':
            if (style == 'filled') {
                iconColor = 'light';
            }
            else if (style == 'outline') {
                iconColor = 'success';
            }
            break;
        case 'danger':
            if (style == 'filled') {
                iconColor = 'light';
            }
            else if (style == 'outline') {
                iconColor = 'danger';
            }
            break;
        case 'warning':
            if (style == 'filled') {
                iconColor = 'light';
            }
            else if (style == 'outline') {
                iconColor = 'warning';
            }
            break;
        case 'info':
            if (style == 'filled') {
                iconColor = 'light';
            }
            else if (style = 'outline') {
                iconColor = 'info';
            }
            break;
    }
    return iconColor;
}

export function constructIconSize(buttonSize: Size): number {
    switch (buttonSize) {
        case 'small':
            return 18
        case 'medium':
            return 20
        case 'large':
            return 24
    }
}
